module.exports = __webpack_public_path__ + "static/media/horse-saddle.88640438.svg";